// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OgMF","largestCol":"styles_largestCol__28tn4","smallestCol":"styles_smallestCol__1WZ2u"};